<div class="page">
  <div class="header">
    <flyht-nav-menu></flyht-nav-menu>
  </div>
  <div class="scroll-container">
    <div class="scroll">
      <div class="content">
        <router-outlet (activate)="changeOfRoutes()"></router-outlet>
      </div>
      <div class="footer">
        <flyht-footer></flyht-footer>
      </div>
    </div>
  </div>
</div>

<p-toast [baseZIndex]="500000" styleClass="custom-toast"></p-toast>
<p-toast [baseZIndex]="500000" position="bottom-right" key="br"></p-toast>

<app-loading-spinner></app-loading-spinner>